import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import imageLoader from './plugins/imageLoader'
import en from '@/assets/lang/en.json'
import no from '@/assets/lang/no.json'
const i18n = createI18n({
  messages: {
    en: en,
    no: no,
  },
});


loadFonts()

createApp(App)
  .use(vuetify)
  .use(i18n)
  .mixin(imageLoader)
  .mount('#app')

